import { useTranslation } from 'react-i18next'

import { AvatarWithStatus } from '../../../../Avatar'
import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import Text from '../../../../Text'
import { ProfileUsersWidgetItem } from '../../../../Widget'
import { QA_NAME_VIEWING_PROFILE_INFO_MANAGER } from '../RentalPortalViewingProfileHeaderInfoItems.constants'

function ViewingProfileManagerItem({
  className,
  contentWrapperClassName,
  managerClassName,
  titleClassName,
  value,
}) {
  const { t } = useTranslation()

  return (
    <EntityProfileHeaderInfoItemBase
      actions={null}
      canEdit={false}
      className={className}
      contentWrapperClassName={contentWrapperClassName}
      title='RentalPortal.ViewingManagerColumnKey'
      titleClassName={titleClassName}
    >
      {value ? (
        <ProfileUsersWidgetItem
          blocked
          AdditionalInfo={null}
          ContentAvatar={AvatarWithStatus}
          className={managerClassName}
          hoverClassName={null}
          textQaName={QA_NAME_VIEWING_PROFILE_INFO_MANAGER}
          value={value}
        />
      ) : (
        <Text disabled isSecondary>
          {t('Select.NoDataKey')}
        </Text>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ViewingProfileManagerItem
